import Image from "next/image";

import { formatImageUrl } from "@/components/blog/Util";
import { BlogImageProps } from "@/types/blog-post";

const microData = {
  itemScope: true,
  itemProp: "image",
  itemType: "https://schema.org/ImageObject",
} as const;

function BlogImage({ src = "", alt = "", caption = "", isLazy = true }: BlogImageProps) {
  return (
    <figure className="mb-8 not-prose" {...microData}>
      <picture>
        <Image
          src={`${formatImageUrl(src)}`}
          alt={alt}
          width={800}
          height={500}
          quality={70}
          className="mx-auto"
          loading={isLazy ? "lazy" : "eager"}
          priority={!isLazy}
        />
      </picture>

      {Boolean(caption) && (
        <figcaption className="block mt-1 text-ash-500 text-sm leading-5 text-center">{caption}</figcaption>
      )}
    </figure>
  );
}

export default BlogImage;
